import { AxiosResponse } from "axios";

export const unwrapAxiosData = <T>(request: Promise<AxiosResponse<T>>): Promise<T> => {
  return request.then((response) => response.data);
};
